import z from "zod";
import { AuditMetaSchema } from "./auditMetaTypes";
import { GrantsSchema } from "./grantsTypes";
import { LabelIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";

export const LabelSchema = z
  .object({
    id: LabelIdSchema,
    name: z.string(),
    description: z.string(),
    icon: z.string(),
    color: z.string(),
    isSystem: z.boolean(),
    grants: GrantsSchema,
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);
export type Label = z.infer<typeof LabelSchema>;

export const LabelAssociationSchema = z
  .object({
    id: z.string(),
    labelId: LabelIdSchema,
    resourceId: z.string(),
    resourceType: z.string(),
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);

export type LabelAssociation = z.infer<typeof LabelAssociationSchema>;
